import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { fecha } from "../lib/formato";
import { Cargando, Panel, Vacio } from "../componentes/piezas";
import { useIdioma } from "../lib/idioma";

interface Noticia {
  id: string;
  titulo: string;
  cuerpo: string;
  fechaPublicacion: string;
  /** Lista JSON con las direcciones de las fotos. */
  imagenes: string;
}

const fotosDe = (json: string): string[] => {
  try {
    const v = JSON.parse(json || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

/** Lo que el club cuenta a sus socios. */
export default function PortalNoticias() {
  const { t } = useIdioma();
  const noticias = useQuery({
    queryKey: ["portal-noticias"],
    queryFn: () => api<Noticia[]>("/portal/noticias"),
  });
  const [ampliada, setAmpliada] = useState<string | null>(null);

  if (noticias.isLoading || !noticias.data)
    return <Cargando texto={t("general.cargando")} />;
  if (noticias.data.length === 0) return <Vacio>{t("noticias.vacio")}</Vacio>;

  return (
    <div className="columna" style={{ gap: 16 }}>
      {noticias.data.map((n) => {
        const fotos = fotosDe(n.imagenes);
        return (
          <Panel key={n.id}>
            <div className="rotulo">{fecha(n.fechaPublicacion)}</div>
            <h2 style={{ margin: "4px 0 8px" }}>{n.titulo}</h2>
            <p style={{ margin: 0, whiteSpace: "pre-wrap" }}>{n.cuerpo}</p>

            {fotos.length > 0 && (
              <div className="galeria" style={{ marginTop: 12 }}>
                {fotos.map((foto) => (
                  <button
                    key={foto}
                    type="button"
                    className="galeria-foto"
                    onClick={() => setAmpliada(foto)}
                  >
                    <img src={foto} alt="" loading="lazy" />
                  </button>
                ))}
              </div>
            )}
          </Panel>
        );
      })}

      {ampliada && (
        <div
          className="visor"
          onClick={() => setAmpliada(null)}
          role="presentation"
        >
          <img src={ampliada} alt="" />
          <button
            className="boton secundario"
            onClick={() => setAmpliada(null)}
          >
            {t("general.cerrar")}
          </button>
        </div>
      )}
    </div>
  );
}
